export default function getPlaceholderForField(fieldID: string): string {
  const formatHints: { [key: string]: string } = {
    email: 'example@email.com',
    phone: '(555) 555-5555',
    zipCode: '29838',
  };

  return formatHints[fieldID] || '';
}
